import React from 'react';
import autoBind from 'react-autobind';

//Context
import accessControlValidation from '@common/validators/accessControl.validator';
import { withGridContext } from './grid.factory';

//Formatters
import DateFormat from '@common/components/formats/date.format';
import DecimalFormat from '@common/components/formats/decimal.format';
import ListFormat from '@common/components/formats/list.format';

import { ResizeSensor } from 'css-element-queries';

import moment from 'moment';
import guid from 'uuid/v1';

import DDadosItem from '@common/components/ddados/ddados.item';
//parts
import GridActionColumn from './grid.actionColumn';

class GridRow extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      toggleDetail: false,
      editor: false,
      editorKey: undefined,
      editorValue: undefined,
    };
  }

  componentWillUnmount() {
    $(window).off('resizeContainer');
  }

  updateContextItem(item) {
    const { context } = this.props;
    const { data } = context;
    data.dataList[this.props.index] = item;
    context.setState({ data });
  }

  clearAllChecks(){
    let { context } = this.props;
    let { data } = context;
    
    data.dataList.forEach(x=> x.isChecked = false);

    context.setState({ data });
  }

  onCheckItem(e) {
    const { checked } = e.target;
    let { item, context } = this.props;
    const { options } = context;

    if(options.selectOnlyOne)
      this.clearAllChecks();

    if (item.merge) item = item.merge({ isChecked: checked });
    else item.isChecked = checked;

    let { dataList } = context.data;

    context.onCheckItem(item, checked, dataList);
    this.updateContextItem(item);
  }

  isCheckDisabled() {
    const { item } = this.props;
    const { context } = this.props;
    const { options } = context;
    if (options.isRowCheckboxDisabled) return options.isRowCheckboxDisabled(item);
    else return false;
  }

  onMouseEnter(e) {
    const $target = $(e.target).parents('tr.hoverRow');
    const index = $target.data('index');
    $("[data-index='" + index + "']").addClass('hover');
  }

  onMouseLeave(e) {
    const $target = $(e.target).parents('tr.hoverRow');
    const index = $target.data('index');
    $("[data-index='" + index + "']").removeClass('hover');
  }

  async toggleDetail(e) {
    function fixHeightElements(hash, shouldToggleAction) {
      const pxAddRow = 30,
        pxAddAction = 44;

      const detailRow = $("[data-index-detail='" + hash + "']");
      const rowHeight = detailRow.height() || 0;

      detailRow.parent().height(rowHeight + pxAddRow);
      const actColumn = $("[data-index-action='" + hash + "']").height(rowHeight + pxAddAction);

      if (shouldToggleAction) actColumn.toggle();
    }

    function calculateHeight(gridHash, shouldToggleAction) {
      setTimeout(() => {
        fixHeightElements(gridHash, shouldToggleAction);
        detailRow.show();

        const parentsDetail = $target.parents('[data-index-detail]');
        parentsDetail.each((x) => fixHeightElements($(parentsDetail[x]).data('index-detail')));
      });
    }

    const $target = $(e.target).parents('tr.hoverRow');
    const gridHash = $target.data('index');
    await this.setState({ toggleDetail: !this.state.toggleDetail });
    const detailRow = $("[data-index-detail='" + gridHash + "']");
    detailRow.hide();
    calculateHeight(gridHash, true);
    new ResizeSensor(detailRow, () => calculateHeight(gridHash));
  }

  setSelectedRow() {
    const { context, index, item } = this.props;
    if (context.masterDetail) {
      context.setState({ selectedRow: index });

      context.masterDetail.setSelected(undefined);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        context.masterDetail.setSelected(item);
      }, 25);
    }
  }

  checkDetailPermission(url) {
    if (Array.isArray(url)) return url.some((x) => accessControlValidation.checkPermissionByUrl(x));
    if (url) return accessControlValidation.checkPermissionByUrl(url);
    return true;
  }

  // Reorder
  reorder(dataItem) {
    if (this.props.context.data.activeItem === dataItem) return;

    const reorderedData = this.props.context.data.dataList.slice();
    const prevIndex = reorderedData.findIndex((p) => p === this.props.context.data.activeItem);
    const nextIndex = reorderedData.findIndex((p) => p === dataItem);
    reorderedData.splice(prevIndex, 1);
    reorderedData.splice(nextIndex, 0, this.props.context.data.activeItem);

    this.props.context.setState({ data: { dataList: reorderedData, activeItem: this.props.context.data.activeItem } });
  }

  handleFieldKeyDown(e, column, columns, indexColumn) {
    const keyCode = e.keyCode;
    if (keyCode == 13) {
      e.preventDefault();
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (!this.validateFieldValue(this.state.editorValue, column)) return;
        this.handleOnEdit(column);
        this.setState({ editor: false, editorKey: undefined, editorValue: undefined });
      }, 50);
    } else if (keyCode === 27) {
      e.preventDefault();
      this.setState({ editor: false, editorKey: undefined, editorValue: undefined });
    } else if (keyCode === 9) {
      e.preventDefault();
      if (!this.validateFieldValue(this.state.editorValue, column)) return;
      this.handleOnEdit(column);
      this.setState({ editor: false, editorKey: undefined, editorValue: undefined });
      if (indexColumn < columns.length - 1) {
        const nextColumn = columns[indexColumn + 1];
        if (nextColumn.show) {
          const { item } = this.props;
          if (nextColumn.format) return nextColumn.format(item);
          const value = item[nextColumn.dataName];
          let key = item['Id'] && nextColumn.onEdit ? `${indexColumn + 1}_${item['Id']}` : guid();
          this.handleEditField(key, value, nextColumn);
        }
      }
    }
  }

  handleFieldBlur(column) {
    if (!this.validateFieldValue(this.state.editorValue, column)) return;
    this.handleOnEdit(column);
    this.setState({ editor: false, editorKey: undefined, editorValue: undefined });
  }

  handleFieldValueChange(value) {
    this.setState({ editorValue: value });
  }

  handleDoubleClick(e, key, value, column) {
    e.preventDefault();
    this.handleEditField(key, value, column); 
  }

  handleEditField(key, value, column) {
    this.setState({
      editor: true,
      editorKey: key,
      editorValue: column.inputField.Tipo !== 'date' ? value : value ? moment(value).format('DD/MM/YYYY') : undefined,
    });
    setTimeout(() => {
      window.document.getElementsByName("editorValue")[0].focus();
    }, 100);
  }

  handleOnEdit(column){
    const value = column.inputField.Tipo === 'date' ? this.fixFieldDate(this.state.editorValue) : this.state.editorValue;

    if(column.inputField.Obrigatorio && (value == undefined || value == null))
      return;

    column.onEdit(value, this.props.item);
  }

  validateFieldValue(value, column) {
    if (
      column.inputField.Obrigatorio &&
      (value === undefined ||
        value === null ||
        value === '' ||
        (column.inputField.Tipo === 'date' && value?.includes('_')))
    ) {
      _alert.error(`Campo ${column.inputField.Label} não deve ser vazio`);
      return false;
    }
    return true;
  }

  fixFieldDate(value) {
    if (!value?.includes('_')) {
      let date = moment(value, 'DD/MM/YYYY');
      return date.isValid() ? date.toDate() : undefined;
    }
    return undefined;
  }

  render() {
    const { columns, item, index, isView } = this.props;
    const { context } = this.props;
    const { hash, options, detail, selectedRow, actions } = context;

    const hasActionColumn = actions.length > 0;

    return (
      <>
        <tr
          className={`hoverRow ${index % 2 ? 'action-strip' : ''} ${selectedRow === index ? 'selected-row' : ''} `}
          data-index={`row-${hash}-${index}`}
          id={index}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        >
          {options.onReorder && (
            <td
              style={{ textAlign: 'center' }}
              title="Reordenar"
              onDragOver={(e) => {
                this.reorder(this.props.item);
                e.preventDefault();
                e.dataTransfer.dropEffect = 'copy';
              }}
            >
              <span
                draggable="true"
                style={{ cursor: 'move' }}
                onDragStart={(e) => {
                  this.props.context.setState({
                    data: { dataList: this.props.context.data.dataList, activeItem: this.props.item },
                  });
                  e.dataTransfer.setData('dragging', '');
                }}
                onDragEnd={(e) => {
                  options.onReorder(this.props.context.data.dataList);
                }}
              >
                <i className="fas fa-arrows-alt-v"></i>
              </span>
            </td>
          )}
          {detail && this.checkDetailPermission(detail.url) && (
            <td
              className=""
              style={{ textOverflow: 'clip', textAlign: 'center', cursor: 'pointer' }}
              onClick={this.toggleDetail}
            >
              <i
                className={`fas fa-angle-right detail-rotate ${this.state.toggleDetail ? 'detail-rotate-down' : null}`}
              ></i>
            </td>
          )}
          {!options.isNotCheckable && (
            <td
              style={{
                textOverflow: 'clip',
                textAlign: 'center',
                position: 'sticky',
                left: '0',
                zIndex: '999',
              }}
              className="checkbox-each"
            >
              <input
                type="checkbox"
                checked={item.isChecked || false}
                onChange={this.onCheckItem}
                disabled={this.isCheckDisabled()}
              />
            </td>
          )}
          {columns.map((column, indexColumn) => {
            if (column.show) {
              const { item } = this.props;
              if (column.format) return column.format(item);
              const value = item[column.dataName];
              let key = item['Id'] && column.onEdit ? `${indexColumn}_${item['Id']}` : guid();
              return (
                <td
                  key={key}
                  className="grid-item"
                  style={{
                    ...(column.onEdit && this.state.editor && this.state.editorKey === key && { userSelect: 'none' }),
                    ...(context.masterDetail && { cursor: 'pointer' }),
                  }}
                  onClick={
                    column.onEdit
                      ? (e) => {
                          this.handleDoubleClick(e, key, value, column);
                        }
                      : context.masterDetail && this.setSelectedRow
                  }
                  onMouseEnter={(e) => {
                    if(this.state.editor)
                      e.target?.removeAttribute('title');

                    e.target?.setAttribute('title', this.getTooltip(column, value));
                  }}
                >
                  {column.onEdit && this.state.editor && this.state.editorKey === key ? (
                    <DDadosItem
                      {...column.inputField}
                      Label={undefined}
                      Tipo={column.inputField.Tipo === 'date' ? 'mask' : column.inputField.Tipo}
                      Mascara={column.inputField.Tipo === 'date' ? 'DYNAMIC' : column.inputField.Mascara}
                      dynamicMask={column.inputField.Tipo === 'date' ? '##/##/####' : column.inputField.dynamicMask}
                      dynamicInitialFixed={
                        column.inputField.Tipo === 'date' ? '__/__/____' : column.inputField.dynamicInitialFixed
                      }
                      Obrigatorio={column.inputField.Obrigatorio ?? false}
                      name={'editorValue'}
                      state={this.state}
                      forceSync={column.forceAsyncOnEdit ?? true}
                      onChange={this.handleFieldValueChange}
                      onBlur={() => this.handleFieldBlur(column)}
                      onKeyDown={(e) => this.handleFieldKeyDown(e, column, columns, indexColumn)}
                      isColumnEdit={true}
                    />
                  ) : (
                    <span className="pointer-events-none ml-1 mr-1">{this.renderItem(column, value)}</span>
                  )}
                </td>
              );
            } else return null;
          })}
          {hasActionColumn && <GridActionColumn index={index} item={item} />}
        </tr>
        {detail && this.state.toggleDetail && (
          <tr className="detail-row">
            <td colSpan={columns.length + 1}>
              <div
                data-index-detail={`row-${hash}-${index}`}
                className={detail.linked ? 'detail-grid-linked' : 'detail-grid'}
                style={{
                  width: `calc(100% - 59px)`,
                }}
              >
                {detail.linked && this.renderLink()}
                {detail.renderDetail(item)}
              </div>
            </td>
          </tr>
        )}
      </>
    );
  }

  renderLink() {
    return (
      <>
        <div id="linked-vertical" className="single-link-vertical" />
        <div id="linked-horizontal" className="single-link-horizontal" />
      </>
    );
  }

  getTooltip(column, value) {
    switch (column.type) {
      case 'decimal':
        return (value != undefined ? value : '').toLocaleString(navigator.language, {
          minimumFractionDigits: column.places || 2,
        });
      case 'date':
        let formatString = this.props.format;
        let date = moment(value);
        if (!formatString) {
          formatString = 'DD/MM/YYYY HH:mm:ss';
          if (column.onlyDate) {
            formatString = 'DD/MM/YYYY';
          }
        }
        return date.isValid() && value ? date.format(formatString) : '';
      case 'lista':
        const { array } = column;
        let input;
        if (typeof value == 'string') {
          input = array.find((x) =>
            typeof x.value != 'string'
              ? x.value == value
              : x.value
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()
                  .trim() ==
                value
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()
                  .trim()
          );
        } else {
          input = array.find((x) => x.value == value);
        }

        if (!input) {
          return value;
        }
        return input.label;
      case 'text':
        if (typeof value !== 'string') return;
        if (column.function) value = column.function(value);
        return value.length > 100 ? `${value.substring(0, 100)}...` : value.trim();
      default:
        return value;
    }
  }

  renderItem(column, value) {
    switch (column.type) {
      case 'decimal':
        return <DecimalFormat prefix={column.prefix} places={column.places} value={value} />;
      case 'date':
        return <DateFormat onlyDate={column.onlyDate} value={value} />;
      case 'lista':
        return <ListFormat array={column.array} field="value" value={value} />;
      default:
        if (column.function) return <span>{column.function(value)}</span>;
        return <span>{value}</span>;
    }
  }
}

export default withGridContext(GridRow);
